import React from "react";

function Solar({ productone, producttwo }) {

    return (
        <div className="bg-white compare-specs rounded p-3">
            <h5>Solar Inverter</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Name</td>
                            <td className="bg-light text-danger fw-bold">{productone?.title}</td>
                            <td className="bg-light text-danger fw-bold">{producttwo?.title}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Inverter Model</td>
                            <td >{productone?.solarinverter?.inverter_model}</td>
                            <td >{producttwo?.solarinverter?.inverter_model}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Rated Output Power</td>
                            <td>{productone?.solarinverter?.rate_output_power}</td>
                            <td>{producttwo?.solarinverter?.rate_output_power}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Output Frequency</td>
                            <td>{productone?.solarinverter?.output_frequency}</td>
                            <td>{producttwo?.solarinverter?.output_frequency}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Max DC Input Current</td>
                            <td>{productone?.solarinverter?.max_dc_input_current}</td>
                            <td>{producttwo?.solarinverter?.max_dc_input_current}</td>
                        </tr>
                        <tr>
                            <td className="text-start">MPPT Range</td>
                            <td>{productone?.solarinverter?.mppt_range}</td>
                            <td>{producttwo?.solarinverter?.mppt_range}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Battery Compatibility</td>
                            <td>{productone?.solarinverter?.battery_compatibility}</td>
                            <td>{producttwo?.solarinverter?.battery_compatibility}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Operating Temperature</td>
                            <td>{productone?.solarinverter?.operating_temperature}</td>
                            <td>{producttwo?.solarinverter?.operating_temperature}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Inverter Warranty</td>
                            <td>{productone?.solarinverter?.inverter_warrenty}</td>
                            <td>{producttwo?.solarinverter?.inverter_warrenty}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Inverter Type</td>
                            <td>{productone?.solarinverter?.inverter_type}</td>
                            <td>{producttwo?.solarinverter?.inverter_type}</td>
                        </tr>
                        <tr>
                            <td className="text-start">DC Input Voltage Range</td>
                            <td>{productone?.solarinverter?.dc_input_voltage_range}</td>
                            <td>{producttwo?.solarinverter?.dc_input_voltage_range}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Number of MPPTs</td>
                            <td>{productone?.solarinverter?.number_of_mppts}</td>
                            <td>{producttwo?.solarinverter?.number_of_mppts}</td>
                        </tr>
                        <tr>
                            <td className="text-start">AC Output Voltage</td>
                            <td>{productone?.solarinverter?.ac_output_voltage}</td>
                            <td>{producttwo?.solarinverter?.ac_output_voltage}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Inverter Efficiency</td>
                            <td>{productone?.solarinverter?.inverter_efficiency}</td>
                            <td>{producttwo?.solarinverter?.inverter_efficiency}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Communication Interface</td>
                            <td>{productone?.solarinverter?.communication_interface}</td>
                            <td>{producttwo?.solarinverter?.communication_interface}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Protection Feature</td>
                            <td>{productone?.solarinverter?.protection_feature}</td>
                            <td>{producttwo?.solarinverter?.protection_feature}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Solar Panel</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Panel Model</td>
                            <td className="bg-light text-danger fw-bold">{productone?.solarpanel?.panel_model}</td>
                            <td className="bg-light text-danger fw-bold">{producttwo?.solarpanel?.panel_model}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Panel Type</td>
                            <td>{productone?.solarpanel?.panel_type}</td>
                            <td>{producttwo?.solarpanel?.panel_type}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Panel Efficiency</td>
                            <td>{productone?.solarpanel?.panel_efficiency}</td>
                            <td>{producttwo?.solarpanel?.panel_efficiency}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Rated Power</td>
                            <td>{productone?.solarpanel?.rate_power}</td>
                            <td>{producttwo?.solarpanel?.rate_power}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Current Max Power</td>
                            <td>{productone?.solarpanel?.current_max_power}</td>
                            <td>{producttwo?.solarpanel?.current_max_power}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Voltage Max Power</td>
                            <td>{productone?.solarpanel?.voltage_max_power}</td>
                            <td>{producttwo?.solarpanel?.voltage_max_power}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Short Circuit Current</td>
                            <td>{productone?.solarpanel?.short_circuit_current}</td>
                            <td>{producttwo?.solarpanel?.short_circuit_current}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Open Circuit Voltage</td>
                            <td>{productone?.solarpanel?.open_circuit_voltage}</td>
                            <td>{producttwo?.solarpanel?.open_circuit_voltage}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Cell Configuration</td>
                            <td>{productone?.solarpanel?.cell_configuration}</td>
                            <td>{producttwo?.solarpanel?.cell_configuration}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Temperature Coefficient</td>
                            <td>{productone?.solarpanel?.temperature_coifficent}</td>
                            <td>{producttwo?.solarpanel?.temperature_coifficent}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Glass Type</td>
                            <td>{productone?.solarpanel?.glass_type}</td>
                            <td>{producttwo?.solarpanel?.glass_type}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Frame Material</td>
                            <td>{productone?.solarpanel?.frame_material}</td>
                            <td>{producttwo?.solarpanel?.frame_material}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Weight</td>
                            <td>{productone?.solarpanel?.weight}</td>
                            <td>{producttwo?.solarpanel?.weight}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Dimensions</td>
                            <td>{productone?.solarpanel?.diminsion}</td>
                            <td>{producttwo?.solarpanel?.diminsion}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Panel Warranty</td>
                            <td>{productone?.solarpanel?.panel_warrenty}</td>
                            <td>{producttwo?.solarpanel?.panel_warrenty}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Accessorie</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">AC Cable</td>
                            <td className="">{productone?.accessorie?.ac_cable}</td>
                            <td className="">{producttwo?.accessorie?.ac_cable}</td>
                        </tr>
                        <tr>
                            <td className="text-start">DC Cable</td>
                            <td>{productone?.accessorie?.dc_cable}</td>
                            <td>{producttwo?.accessorie?.dc_cable}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Battery</td>
                            <td>{productone?.accessorie?.battery}</td>
                            <td>{producttwo?.accessorie?.battery}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Charge Controller</td>
                            <td>{productone?.accessorie?.charge_controller}</td>
                            <td>{producttwo?.accessorie?.charge_controller}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Combine Box</td>
                            <td>{productone?.accessorie?.combine_box}</td>
                            <td>{producttwo?.accessorie?.combine_box}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Connector</td>
                            <td>{productone?.accessorie?.connector}</td>
                            <td>{producttwo?.accessorie?.connector}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Fuses / Breaker</td>
                            <td>{productone?.accessorie?.fuses_breaker}</td>
                            <td>{producttwo?.accessorie?.fuses_breaker}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Surge Protector</td>
                            <td>{productone?.accessorie?.surge_protector}</td>
                            <td>{producttwo?.accessorie?.surge_protector}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Mounting Structure</td>
                            <td>{productone?.accessorie?.mounting_structure}</td>
                            <td>{producttwo?.accessorie?.mounting_structure}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Monitoring Device</td>
                            <td>{productone?.accessorie?.monitoring_device}</td>
                            <td>{producttwo?.accessorie?.monitoring_device}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Earthing Kit</td>
                            <td>{productone?.accessorie?.earthing_kit}</td>
                            <td>{producttwo?.accessorie?.earthing_kit}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Solar;